import {
  SelectedResources,
  VisitCreatingFormData,
} from '@lmt/unicorn-shared/app/components/calendar/visit/common/types';
import i18next from 'i18next';
import * as yup from 'yup';
import { SearchInputPatientData } from '../../../common/patient/PatientSearch';
import { ContactType, WaitingListPriority } from '@lmt/shared-types';

function t(value: string, options?: any) {
  return i18next.t(`translation:errors.${value}` as any, options);
}

const requiredMessage = () => i18next.t('translation:errors.required');
export const visitYupSchema: yup.Schema<VisitCreatingFormData> = yup.object({
  patient: yup
    .mixed<SearchInputPatientData>()
    .nullable()
    .required(requiredMessage),
  caseId: yup.number().nullable().required(requiredMessage),
  resources: yup.mixed<SelectedResources>().defined(),
  visitTypeId: yup.number().nullable().required(requiredMessage),
  note: yup.string().nullable().trim().max(1000).defined(),
  alertPatient: yup.number().nullable().defined(),
  waitingList: yup.boolean().required(requiredMessage),
  priority: yup.mixed<WaitingListPriority>().nullable().defined(),
  dateTimeInterval: yup.object().shape({
    startDate: yup
      .date()
      .nullable()
      .required(requiredMessage)
      .typeError(() => t('invalid_date')),
    startTimeInMills: yup
      .number()
      .nullable()
      .required(requiredMessage)
      .typeError(() => t('invalid_time')),
    endDate: yup
      .date()
      .nullable()
      .required(requiredMessage)
      .typeError(() => t('invalid_date')),
    endTimeInMills: yup
      .number()
      .nullable()
      .required(requiredMessage)
      .typeError(() => t('invalid_time')),
  }),
  priorityContactType: yup.mixed<ContactType>().nullable().defined(),
  takenTimeSlots: yup.array().of(yup.mixed<Interval>().defined()).defined(),
  attendingDoctorId: yup.number().nullable(),
  statusId: yup.mixed().nullable() as any,
  number: yup
    .string()
    .trim()
    .test(
      'undefined-or-not-empty',
      () => i18next.t('translation:errors.required'),
      (value, context) =>
        !context.parent.id ||
        (typeof value === 'string' && value.trim().length > 0),
    )
    .max(20, () =>
      i18next.t('translation:errors.max_length', { maxLength: 20 }),
    ),
  numberSource: yup.mixed() as any,
  id: yup.number().nullable().defined(),
});
